import { useNavigate } from "react-router-dom";
import { loginTargetMap } from "../../../constants/Demo/auth";

export const useRedirectAfterSignIn = ({ prefix = "/login" }) => {
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(window.location.search);
  //   const queryParams = new URLSearchParams(location.search);

  return (user) => {
    const path = window.location.pathname;
    const isPhysioLogin = path.includes(prefix + "/physio") || path === "/";

    if (user.claims.patientId && isPhysioLogin) {
      navigate(loginTargetMap["patient"]);
    }
    if (isPhysioLogin) {
      navigate(loginTargetMap["physio"]);
    }
    if (window.location.pathname.includes(prefix + "/schedule_results")) {
      navigate(
        loginTargetMap["schedule_results"] + "/" + queryParams.get("scheduleId")
      );
    }
    if (window.location.pathname.includes(prefix + "/roadmap")) {
      navigate(loginTargetMap["roadmap"] + "/" + queryParams.get("roadmapId"));
    }
  };
};
